import styled from 'styled-components'

export const Favourite = styled.img`
    width:36px;
    height:36px;
    display:flex;
    align-items: center;
    margin-right:30px;
    cursor:pointer;
`;

